import { Card } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { useTranslation } from "@/contexts/LanguageContext";

interface ChurnChartProps {
  data?: Array<{ month: string; churn: number; target: number }>;
}

export function ChurnChart({ data }: ChurnChartProps) {
  const { t } = useTranslation();
  const chartData = data && data.length > 0 ? data : [
    { month: "Jan", churn: 2.3, target: 3.0 },
    { month: "Fev", churn: 2.8, target: 3.0 },
    { month: "Mar", churn: 2.1, target: 3.0 },
    { month: "Abr", churn: 3.2, target: 3.0 },
    { month: "Mai", churn: 2.5, target: 3.0 },
    { month: "Jun", churn: 1.9, target: 3.0 },
  ];
  return (
    <Card className="p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold">{t('churnRateTitle')}</h3>
        <p className="text-sm text-muted-foreground">{t('churnRateSubtitle')}</p>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis 
            dataKey="month" 
            stroke="hsl(var(--muted-foreground))"
            fontSize={12}
          />
          <YAxis 
            stroke="hsl(var(--muted-foreground))"
            fontSize={12}
            tickFormatter={(value) => `${value}%`}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "hsl(var(--card))",
              border: "1px solid hsl(var(--border))",
              borderRadius: "var(--radius)",
            }}
            formatter={(value: number) => `${value}%`}
          />
          <Legend />
          <Bar
            dataKey="churn"
            fill="hsl(var(--primary))"
            radius={[8, 8, 0, 0]}
            name={t('realChurn')}
          />
          <Bar
            dataKey="target"
            fill="hsl(var(--muted))"
            radius={[8, 8, 0, 0]}
            name={t('target')}
          />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
}
